module.exports = __webpack_public_path__ + "static/img/99.6b4c250.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/99.png
// module id = sl+3
// module chunks = 1